import { useEffect } from 'react';

import { CollectionPermissions, CollectionsContext, SelectablePartner } from 'pages/partners/pages/collections/context';
import { GMetrixLoader } from 'components/GMetrixLoader/GMetrixLoader';
import { AvailablePartner, CollectionApi } from 'apis/CollectionApi';
import { NotificationContextProvider } from 'app/notifications';
import { Outlet } from 'react-router-dom';
import { PermissionsApi } from 'apis';
import { useSuperState } from 'hooks';
import { useIntl } from 'react-intl';
import { useApp } from 'app';

import { DefaultLayout } from '../../../../components/layout';

export const CollectionsWrapper = () => {

    const { highestRole } = useApp();
    const { formatMessage } = useIntl();
    const [state, setState] = useSuperState({
        availablePartners: [] as SelectablePartner[],
        loading: true,
        permissions: null as CollectionPermissions
    });

    const { availablePartners, loading, permissions } = state;

    const resolvedRoleId = highestRole.id ?? 0;
    const showAdvancedColumns = resolvedRoleId === 1 || resolvedRoleId === 2;
    const showLoginFields = resolvedRoleId === 1;

    useEffect(() => {

        const load = async () => {

            try {

                const [perms, partners] = await Promise.all([
                    PermissionsApi.Get('Collection'),
                    CollectionApi.GetAvailablePartners()
                ]);

                setState({
                    availablePartners: partners.map((p: AvailablePartner) => ({
                        Active: p.Active,
                        ContactEmail: p.ContactEmail,
                        Country: p.Country ?? undefined,
                        DateCreate: p.DateCreate,
                        ID: p.ID,
                        Name: p.Name,
                        Sector: p.Sector,
                        State: p.State ?? undefined,
                        UserList: p.UserList
                    })),
                    loading: false,
                    permissions: perms
                });

            } catch (e) {

                console.error(e);
                setState({ loading: false });

            }

        };

        load();

    }, []);

    const context = {
        availablePartners,
        permissions: permissions ?? { Create: false, Edit: false, View: false },
        showAdvancedColumns,
        showLoginFields
    };

    return (
        <DefaultLayout pageTitle={formatMessage({ id: 'associations.a5026e86', defaultMessage: 'Associations' })}>
            {loading ?
                (
                    <div className={'flex-fill d-flex align-items-center justify-content-center p-5'}>
                        <GMetrixLoader />
                    </div>
                )
                :
                (
                    <NotificationContextProvider>
                        <CollectionsContext.Provider value={context}>
                            <Outlet />
                        </CollectionsContext.Provider>
                    </NotificationContextProvider>
                )
            }
        </DefaultLayout>
    );

};
